import React from 'react';
import TutorialLayout from '../components/TutorialLayout';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { getHostname } from '../utils/getHostname';

function Guide() {
  const hostname = getHostname();
  useDocumentTitle('VPN Setup Guide');
  
  return (
    <TutorialLayout
      title="VPN Setup Guide"
      description={`Complete guide to setting up and connecting to ${hostname} VPN on various platforms.`}
    >
      <p>
        After a successful purchase, or when you open the link from your email, you will see a popup where you can download your {hostname} VPN credentials.
        The platform guides below walk you through using those credentials to connect.
      </p>
      <h4>Choose Your Platform</h4>
      <p>Select your device or operating system to view detailed setup instructions:</p>
      
      <div style={{ marginTop: '30px' }}>
        <h5><a href="/tutorials/vpn_connect_windows">Windows Setup</a></h5>
        <p>Step-by-step instructions for setting up VPN on Windows 7, 8, 10, and 11.</p>
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <h5><a href="/tutorials/vpn_connect_mac">Mac Setup</a></h5>
        <p>Complete guide for configuring VPN on macOS.</p>
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <h5><a href="/tutorials/vpn_connect_ubuntu">Linux Setup</a></h5>
        <p>Instructions for setting up VPN on Linux distributions including Ubuntu, Debian, Fedora, and more.</p>
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <h5><a href="/tutorials/vpn_connect_android">Android Setup</a></h5>
        <p>Guide for configuring VPN on Android devices.</p>
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <h5><a href="/tutorials/vpn_connect_ios_app">iPhone/iPad Setup</a></h5>
        <p>Step-by-step instructions for setting up VPN on iOS devices.</p>
      </div>
    </TutorialLayout>
  );
}

export default Guide;
